import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data:[],
    isAddingOrder:false,
    status:null,
}

const token = userObj?.token

export const addOrder = createAsyncThunk(
    'order/addOrder',
    async (data, {rejectWithValue}) => {
        
        try{
            const response = await axios.post("/Order/addOrder",data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const addOrderSlice = createSlice({
    name: 'addOrder',
    initialState,
    reducers: {},
    extraReducers:{
        [addOrder.pending]: (state, action) => {
            state.status='pending';
            state.isAddingOrder=true;
        },
        [addOrder.fulfilled]: (state, action) => {
            state.status='success';
            state.isAddingOrder=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [addOrder.rejected]: (state, action) => {
            state.status='failed';
            state.isAddingOrder=false;
        }
    }
})

export default addOrderSlice.reducer;